import { render, staticRenderFns } from "./FooterTopCategories.vue?vue&type=template&id=6efacbe2&scoped=true&"
import script from "./FooterTopCategories.vue?vue&type=script&lang=ts&"
export * from "./FooterTopCategories.vue?vue&type=script&lang=ts&"
import style0 from "./FooterTopCategories.vue?vue&type=style&index=0&id=6efacbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efacbe2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default,AtomsTextLink: require('/var/www/packages/theme/components/atoms/TextLink.vue').default,AtomsAccordion: require('/var/www/packages/theme/components/atoms/Accordion.vue').default})
